module.exports = __webpack_public_path__ + "static/media/cases_impressos_nec_03.1642e55c.jpg";